import { faGears, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const PrinterTypeMark = ({ className }) => (
  <span className={classNames('printer-type-mark', className)}>
    <FontAwesomeIcon icon={faPrint} />
    <FontAwesomeIcon icon={faGears} className='printer-type-mark-gear' />
  </span>
);

PrinterTypeMark.propTypes = {
  className: PropTypes.string,
};

PrinterTypeMark.defaultProps = {
  className: null,
};

export default PrinterTypeMark;
